import ItemsCountingDashboard from './ItemsCountingDashboardContainer';

export default ItemsCountingDashboard;
